import { ImportSteps, ImportTypes } from 'client/components/Screen/ImportScreen/ImportScreen'
import { Screens } from 'client/components/Screen/ScreenConnector'

export interface ScreenPayloadInterface<Screen extends Screens, Props> {
  name: Screen
  props: Props
}

interface ScreenActionInterface<Screen extends Screens, Props> {
  type: string
  payload: ScreenPayloadInterface<Screen, Props>
}

/**
 * Removes currently active screen from view
 */
export const closeScreen = () => {
  return {
    type: 'NAVIGATE_CLOSE_SCREEN',
  }
}

/**
 * Opens a specific screen. Don't call this function with dispatch directly, but rather create a specific
 * function for your screen that has the required parameters for that screen.
 *
 * @param screen
 * @param props
 */
const openScreen = <Screen extends Screens, Props>(
  screen: Screen,
  props: Props,
): ScreenActionInterface<Screen, Props> => {
  return {
    type: 'NAVIGATE_OPEN_SCREEN',
    payload: {
      name: screen,
      props,
    },
  }
}

/**
 * Displays the import screen at a selected step
 *
 * @param type
 * @param step
 */
export const openImportScreen = (type: ImportTypes, step: ImportSteps = 'Picker') => {
  return openScreen('Import', {
    step,
    type,
  })
}
